const ADMIN_ROLE = {
    MERCHANT_ADMIN: "Super Admin",
    TEMPLATE_ADMIN: "Template Admin",
    ORDER_ADMIN: "Order Admin",
    DATA_ENTRY_ADMIN: "Data Entry Admin",
};

export default ADMIN_ROLE;